"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DetailRow from "./DetailRow";
import { useEnquiryFlowStore } from "@/store/enquiryFlowStore";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
const ICON_SX = {
  fontSize: "22px"
};

// Shows whatever was filled in on the mandatory get-in-touch form (name,
// contact, scope of work, site location, flat number). Edit pencil re-opens
// the mandatory sheet with this data still in the flow store's draft.
export default function ClientDetailsCard(t0) {
  const $ = _c(36);
  const {
    data: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  const editMandatory = useEnquiryFlowStore(_temp);
  const digitalProfile = useEnquiryFlowStore(_temp2);
  const track = useInhomzTrack();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/icons/contract_edit.svg" alt="" width={22} height={22} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data.scopeOfWork) {
    t4 = {
      key: "scopeOfWork",
      icon: t3,
      label: "Scope of work",
      value: data.scopeOfWork
    };
    $[3] = data.scopeOfWork;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PersonOutlinedIcon sx={ICON_SX} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== data.fullName) {
    t6 = {
      key: "fullName",
      icon: t5,
      label: "Your name",
      value: data.fullName
    };
    $[6] = data.fullName;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LocalPhoneOutlinedIcon sx={ICON_SX} />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== data.contactNumber) {
    t8 = {
      key: "contactNumber",
      icon: t7,
      label: "Your contact number",
      value: data.contactNumber
    };
    $[9] = data.contactNumber;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LocationOnOutlinedIcon sx={ICON_SX} />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== data.siteLocation) {
    t10 = {
      key: "siteLocation",
      icon: t9,
      label: "Project location",
      value: data.siteLocation
    };
    $[12] = data.siteLocation;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <HomeOutlinedIcon sx={ICON_SX} />;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== data.flatNumber) {
    t12 = {
      key: "flatNumber",
      icon: t11,
      label: "Flat / House / Apartment No.",
      value: data.flatNumber
    };
    $[15] = data.flatNumber;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t12 || $[19] !== t4 || $[20] !== t6 || $[21] !== t8) {
    t13 = [t4, t6, t8, t10, t12];
    $[17] = t10;
    $[18] = t12;
    $[19] = t4;
    $[20] = t6;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const rows = t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <h2 className="m3-title-medium text-[--textPrimaryPrimary]">Client details</h2>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== digitalProfile || $[25] !== editMandatory || $[26] !== track) {
    t15 = () => {
      track(inhomzEvents.reviewForm.CLIENT_EDIT_CLICKED, profileEventProps(digitalProfile));
      editMandatory();
    };
    $[24] = digitalProfile;
    $[25] = editMandatory;
    $[26] = track;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <EditOutlinedIcon sx={{
      fontSize: "20px"
    }} className="text-[--colorPrimaryPrimary]" />;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15) {
    t17 = <div className="flex items-center justify-between">{t14}<button type="button" onClick={t15} aria-label="Edit client details">{t16}</button></div>;
    $[29] = t15;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== rows) {
    t18 = <div className="flex flex-col divide-y divide-[--colorSecondarySecondaryContainer] rounded-[--radius28] bg-[--colorSurfaceSurface]">{rows.map(_temp3)}</div>;
    $[31] = rows;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <section className="flex flex-col gap-3">{t17}{t18}</section>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  return t19;
}
function _temp3(row) {
  return <DetailRow key={row.key} icon={row.icon} label={row.label} value={row.value} />;
}
function _temp2(state_0) {
  return state_0.digitalProfile;
}
function _temp(state) {
  return state.editMandatory;
}